export const tasks = state => state.tasks
export const task = state => state.task